import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import SortSelect from '@/components/Base/SortSelect';

import { ListHeader, TextCount } from './ProductsListHeader.styles';

export const SORTER = ['popular', 'lowestRate', 'biggestAmount', 'longestTerm'];

function ProductsListHeader({ count = 0 }) {
  const { formatMessage } = useIntl();

  return (
    <ListHeader>
      <TextCount>
        {formatMessage({ id: 'cardsListHeader.count' }, { count })}
      </TextCount>

      <SortSelect options={SORTER} />
    </ListHeader>
  );
}

ProductsListHeader.propTypes = {
  count: PropTypes.number,
};

export default memo(ProductsListHeader);
